<mat-dialog-content>
  <div class="flex justify-center content-center items-center flex-col">
    <h3 translate="">Expected rent income</h3>
    <h3>{{ this.marketRentInfo.expectedRentIncome | currency:'EUR':'symbol':'1.2-2' }}</h3>
  </div>
  <p>
    {{ 'Based on' | translate }} {{ this.marketRentInfo.expectedRentIncomeMatchCount }} {{ 'matching buildings based on the following properties' | translate }}
  </p>
  <mat-list class="mb2">
    @for (attribute of this.attributes; track attribute) {
      <mat-list-item class="underline">
        <div class="flex justify-between content-center items-center flex-row basis-full">
          <div>{{ attribute.name }}</div>
          <div [ngClass]="{'green': attribute.isMatched, 'red': !attribute.isMatched}" class="flex flex-row justify-start content-center items-center h-full">
            {{ attribute.value }}
            @if (attribute.isMatched) {
              <mat-icon class="ml1">check</mat-icon>
            }
            @if (!attribute.isMatched) {
              <mat-icon class="ml1">clear</mat-icon>
            }
          </div>
        </div>
      </mat-list-item>
    }
  </mat-list>
</mat-dialog-content>
<mat-dialog-content class="flex justify-center content-center items-center flex-row">
  <button mat-stroked-button="" [mat-dialog-close]="true"><span translate="">Close</span></button>
</mat-dialog-content>